import { z } from "zod";
import { dmaAmountDtoSchema } from "./dma-amount.schema";
import { dmaIngredientKindDtoSchema } from "./dma-ingredient-kind.schema";
import { dmaPhaseDtoSchema } from "./dma-phase.schema";
export const dmaIngredientDtoSchema = z.object({
    ingredientKind: dmaIngredientKindDtoSchema,
    ingredientId: z.number(),
    amount: dmaAmountDtoSchema,
    phase: dmaPhaseDtoSchema,
});
